<template>
  <div
    class="cardRegister container px-2 py-2 border border-secondary-subtle position-fixed top-50 start-50 translate-middle p-3">
    <button class="btn-close float-end mt-3 me-3" @click.prevent="close"></button>
    <h4 class="mt-3"><strong>Registrar grupo de formas</strong></h4>
    <div class="row aling-items-center mt-3 mb-3">
      <div class="col-sm-5">
        <label for="familytype">Línea:</label>
      </div>
      <div class="col-sm-5">
        <select class="form-select" id="familytype" v-model="familytype">
          <option value="0" selected>Seleccione una opción...</option>
          <option value="Laminas">Láminas</option>
          <option value="Perfiles">Perfiles</option>
          <option value="Tubos">Tubos</option>
        </select>
      </div>
    </div>
    <div class="row aling-items-center mt-3 mb-3">
      <div class="col-sm-5">
        <label for="familyname">Nombre del grupo de formas:</label>
      </div>
      <div class="col-sm-5">
        <input type="text" v-model="familyname" class="form-control" id="familyname" />
      </div>
    </div>
    <div class="row aling-items-center mt-3 mb-3">
      <div class="col-sm-5">
        <label for="familyorder">Orden del grupo de formas: </label>
      </div>
      <div class="col-sm-5">
        <input type="number" v-model="familyorder" class="form-control" id="familyorder" step="1" min="0" />
      </div>
    </div>
    <div class="row aling-items-center mt-3 mb-3">
      <div class="col-sm-5">
        <label for="familyImage">Imagen representativa para el grupo de formas: </label>
      </div>
      <div class="col-sm-5">
        <input type="file" class="form-control" id="familyImage" ref="file" @change="previewFile" />
      </div>
    </div>
    <p><mark>Ahora, seleccione aquellas familias de materia prima con las que se puede frabicar el grupo de formas
        anterior.</mark></p>
    <div class="mt-4 mb-4 ms-4 me-4">
      <div class="row mt-3 mb-2">
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial1" v-model="rawMaterial1"
            @change="getRawMaterial1" />
          <label class="form-check-label" for="rawMaterial1">Lámina metálica en Acero al Carbono <i>(HR / CR /
              Alfajor)</i></label>
        </div>
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial3" v-model="rawMaterial3"
            @change="getRawMaterial3" />
          <label class="form-check-label" for="rawMaterial3">Lámina metálica en Acero Inoxidable</label>
        </div>
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial4" v-model="rawMaterial4"
            @change="getRawMaterial4" />
          <label class="form-check-label" for="rawMaterial4">Lámina metálica en Aluminio</label>
        </div>
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial2" v-model="rawMaterial2"
            @change="getRawMaterial2" />
          <label class="form-check-label" for="rawMaterial2">Lámina metálica en Acero al Carbono
            <i>(Antidesgaste)</i></label>
        </div>
      </div>
      <div class="row mt-3 mb-2">
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial5" v-model="rawMaterial5"
            @change="getRawMaterial5" />
          <label class="form-check-label" for="rawMaterial5">Perfil estructural tipo canal en "U" en Acero al
            Carbono</label>
        </div>
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial6" v-model="rawMaterial6"
            @change="getRawMaterial6" />
          <label class="form-check-label" for="rawMaterial6">Perfil estructural tipo viga en "I" en Acero al
            Carbono</label>
        </div>
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial7" v-model="rawMaterial7"
            @change="getRawMaterial7" />
          <label class="form-check-label" for="rawMaterial7">Perfil estructural tipo viga en "H" en Acero al
            Carbono</label>
        </div>
        <div class="form-check form-switch col-sm-3 col-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial8" v-model="rawMaterial8"
            @change="getRawMaterial8" />
          <label class="form-check-label" for="rawMaterial8">Perfil estructural tipo ángulo "L" en Acero al Carbono e
            Inoxidable</label>
        </div>
      </div>
      <div class="row mt-3 mb-2">
        <div class="form-check form-switch col-3 col-sm-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial9" v-model="rawMaterial9"
            @change="getRawMaterial9" />
          <label class="form-check-label" for="rawMaterial9">Tubería estructural en acero al carbono <i>(HR)</i></label>
        </div>
        <div class="form-check form-switch col-3 col-sm-3">
          <input class="form-check-input" type="checkbox" role="switch" id="rawMaterial10" v-model="rawMaterial10"
            @change="getRawMaterial10" />
          <label class="form-check-label" for="rawMaterial10">Tubería tipo mueble en Acero al Carbono
            <i>(CR)</i></label>
        </div>
      </div>
    </div>
    <div>
      <button class="btn btn-danger mb-3" @click.prevent="registerNewFamily">
        Guardar grupo de formas
      </button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
import Swal from "sweetalert2/dist/sweetalert2.js";
//import 'sweetalert2/src/sweetalert2.scss'
export default {
  data() {
    return {
      familytype: "",
      familyname: "",
      familyorder: 0,
      imageFile: undefined,
      currentFile: undefined,
      rawMaterial1: false,
      rawMaterial2: false,
      rawMaterial3: false,
      rawMaterial4: false,
      rawMaterial5: false,
      rawMaterial6: false,
      rawMaterial7: false,
      rawMaterial8: false,
      rawMaterial9: false,
      rawMaterial10: false,
      materials: [],
      rawPrefix: "MAT_",
    };
  },
  methods: {
    previewFile(event) {
      this.imageFile = this.$refs.file.files;
      // console.log(this.imageFile);
      this.currentFile = this.imageFile.item(0);
      // console.log(this.currentFile);
    },
    getRawMaterial1() {
      this.rawMaterial1
        ? this.materials.push(this.rawPrefix + "ACERO_CARBONO")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial2() {
      this.rawMaterial2
        ? this.materials.push(this.rawPrefix + "ANTIDESGASTE")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial3() {
      this.rawMaterial3
        ? this.materials.push(this.rawPrefix + "INOXIDABLE")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial4() {
      this.rawMaterial4
        ? this.materials.push(this.rawPrefix + "ALUMINIO")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial5() {
      this.rawMaterial5
        ? this.materials.push(this.rawPrefix + "CANAL_U")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial6() {
      this.rawMaterial6
        ? this.materials.push(this.rawPrefix + "VIGA_I")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial7() {
      this.rawMaterial7
        ? this.materials.push(this.rawPrefix + "VIGA_H")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial8() {
      this.rawMaterial8
        ? this.materials.push(this.rawPrefix + "ANGULO")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial9() {
      this.rawMaterial9
        ? this.materials.push(this.rawPrefix + "ESTRUCTURAL")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    getRawMaterial10() {
      this.rawMaterial10
        ? this.materials.push(this.rawPrefix + "MUEBLE")
        : console.log("Without raw mat1");
      // console.log(this.materials)
    },
    async registerNewFamily() {
      //console.log("Call de function!")
      // console.log(this.materials);
      // console.log(JSON.stringify(this.materials));
      if (
        this.familytype == "" ||
        this.familyname == "" ||
        this.familyorder == 0 ||
        this.currentFile == undefined ||
        !(this.materials.length > 0)
      ) {
        alert(
          "Alguno de los campos está vácio, no se puede realizar el registro de la familia o el grupo de formas"
        );
      } else {
        let formData = new FormData();
        formData.append("imgFormFamily_type", this.familytype);
        formData.append("imgFormFamily_name", this.familyname);
        formData.append("imgFormFamily_order", this.familyorder);
        formData.append("imgFormFamily_image", this.currentFile);
        formData.append("familyRaw_materials", JSON.stringify(this.materials));
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/imgFormFamily/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          //console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            alert("Familia " + this.familyname + " creada con exito!");
            //Swal.fire('Familia de formas creada con exito')
            this.cleanFields();
            this.close();
            location.reload();
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    cleanFields() {
      this.familytype = "0";
      this.familyname = "";
      this.familyorder = 0;
      this.rawMaterial1 = false;
      this.rawMaterial2 = false;
      this.rawMaterial3 = false;
      this.rawMaterial4 = false;
      this.rawMaterial5 = false;
      this.rawMaterial6 = false;
      this.rawMaterial7 = false;
      this.rawMaterial8 = false;
      this.rawMaterial9 = false;
      this.rawMaterial10 = false;
      this.materials = [];
    },
    close() {
      this.$emit("hideCreateFormFamily", false)
    }
  },
};
</script>
<style scoped></style>